import "./ChannelSearch.css";

import queryString from "query-string";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";

import { fetchFindStation, fetchLocationSearch } from "../actions";
import ChannelSearchViewer from "../components/ChannelSearchViewer";
import LocationList from "../components/LocationList";

class ChannelSearch extends Component {
  componentDidMount() {
    const parameters = queryString.parse(this.props.location.search);
    if (parameters.city) this.props.fetchLocationSearch(parameters.city);
    else if (parameters.lat && parameters.lon)
      this.props.fetchFindStation(parameters.lat, parameters.lon);
  }

  componentDidUpdate(prevProps) {
    const parameters = queryString.parse(this.props.location.search);
    const prevParameters = queryString.parse(prevProps.location.search);

    const hasCoords = parameters.lat && parameters.lon;
    const hasCoordsChanged =
      parameters.lat !== prevParameters.lat ||
      parameters.lon !== prevParameters.lon;
    const hasCity = parameters.city;
    const hasCityChanged = parameters.city !== prevParameters.city;

    if (hasCity && hasCityChanged)
      this.props.fetchLocationSearch(parameters.city);
    else if (hasCoords && hasCoordsChanged)
      this.props.fetchFindStation(parameters.lat, parameters.lon);
  }

  render() {
    const parameters = queryString.parse(this.props.location.search);

    return (
      <div className="channel-search">
        <Switch>
          <Route path="/find">
            {parameters.lat && parameters.lon && (
              <ChannelSearchViewer
                lat={parameters.lat}
                lng={parameters.lon}
                channels={this.props.stationSearch.result}
              />
            )}
            {parameters.city && (
              <LocationList locations={this.props.locationSearch.result} />
            )}
          </Route>
        </Switch>
      </div>
    );
  }
}

export default withRouter(
  connect(
    ({ channel }) => ({
      stationSearch: channel.stationSearch,
      locationSearch: channel.locationSearch
    }),
    { fetchLocationSearch, fetchFindStation }
  )(ChannelSearch)
);
